<script setup lang="ts">
import { EventNameDateIdTypeAheadLine, TypeAhead } from '@/components';
import { BibAssignSort, TypeAheadItem, TypeAheadResponse } from '@/objects/generated';
import { EventDao, SeriesDao, SeedingListDao } from '@/dao';
import { onMounted, ref } from 'vue';
import { TypeAheadDataSource, type TypeAheadExpose } from '@/components/Typeahead';

const props = defineProps<{ row: BibAssignSort; stopEditing: () => void }>();

const value = defineModel<number | null>({ required: true });

const resultText = ref<string>('');
const seriesText = ref<string>('');
const seedingListText = ref<string>('');

onMounted(async () => {
    if (props.row?.SortType == 'Result') {
        if (!value.value) {
            resultText.value = '';
            return;
        }
        const current = await EventDao.EventAsSelectLine(value.value as number);
        resultText.value = current?.text || '';
    } else if (props.row?.SortType == 'Series') {
        if (!value.value) {
            seriesText.value = '';
            return;
        }
        const current = await SeriesDao.SeriesAsSelectLine(value.value as number);
        seriesText.value = current?.text || '';
    } else if (props.row?.SortType == 'SeedingList') {
        if (!value.value) {
            resultText.value = '';
            return;
        }
        const current = await SeedingListDao.SeedingListAsSelectLine(value.value as number);
        resultText.value = current?.text || '';
    }
});

const resultDatasource = new TypeAheadDataSource('Contains', async (request) => {
    const results = await EventDao.TypeaheadSearch(request);
    const response = TypeAheadResponse.FromJsValues({
        Items: results,
    });
    return response;
});

const seriesDatasource = new TypeAheadDataSource('Contains', async (request) => {
    const result = await SeriesDao.TypeaheadSearch(request);
    return result || TypeAheadResponse.FromJsValues({}); // TODO: Håndtere feil her?
});

const seedingListDatasource = new TypeAheadDataSource('Contains', async (request) => {
    const result = await SeedingListDao.TypeaheadSearch(request);
    return result || TypeAheadResponse.FromJsValues({}); // TODO: Håndtere feil her?
});

const resultSelected = (e: TypeAheadItem) => {
    value.value = e.ID;
    props.stopEditing();
};

const seriesSelected = (e: TypeAheadItem) => {
    value.value = e.ID;
    props.stopEditing();
};

const seedingListSelected = (e: TypeAheadItem) => {
    value.value = e.ID;
    props.stopEditing();
};

const resulttypeahead = ref<TypeAheadExpose | null>(null);
const seriestypeahead = ref<TypeAheadExpose | null>(null);
const seedinglisttypeahead = ref<TypeAheadExpose | null>(null);

defineExpose({
    focus: () => {
        switch (props.row?.SortType) {
            case 'Result':
                resulttypeahead.value?.focus();
                break;
            case 'Series':
                seriestypeahead.value?.focus();
                break;
            case 'SeedingList':
                seedinglisttypeahead.value?.focus();
                break;
        }
    },
});
</script>
<template>
    <div>
        <TypeAhead
            v-if="props.row?.SortType == 'Result'"
            v-model="resultText"
            :datasources="[resultDatasource]"
            :displayItemComponent="EventNameDateIdTypeAheadLine"
            @item-selected="resultSelected"
            ref="resulttypeahead"
        />
        <TypeAhead
            v-if="props.row?.SortType == 'Series'"
            v-model="seriesText"
            :datasources="[seriesDatasource]"
            @item-selected="seriesSelected"
            ref="seriestypeahead"
        />
        <TypeAhead
            v-if="props.row?.SortType == 'SeedingList'"
            v-model="seedingListText"
            :datasources="[seedingListDatasource]"
            @item-selected="seedingListSelected"
            ref="seedinglisttypeahead"
        />
    </div>
</template>
